/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import style from '../../../../../assets/styles/testCreationStyle.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination } from '../../../common/Pagination';
import {
  Duplicate_Test,
  Get_Test_Deatils,
  Get_Test_Detail_For_Edit,
  Get_Test_list,
  Published_Test,
  Unpublish_Test,
  changeAdd_test_screen,
  change_test_screen,
} from '../../../../../redux/action';

import styleModal from '../../../../../assets/styles/modalStyle.module.css';
// import TaskFilterModal from "../../../../atoms/Modal/TaskFilterModal";
import TestFilterModal from '../../../../atoms/Modal/TestFilterModal';
import moment from 'moment';
import NativeButton from '../../../../atoms/Button';
import { CallWithAuth } from '../../../../../action/apiActions';
import { GET_TEST_LISTS, IMS_TEST_STATUS, TEST_PLAYER_STATUS } from '../../../../../action/apiPath';
import { useToast } from '../../../common/Toast';
import { GET_TEST_LISTING_FAIL, GET_TEST_LISTING_SUCCESS } from '../../../../../redux/constant';
import { useNavigate } from 'react-router-dom';
import RightPanelTopMenu from '../../../common/RightPanelTopMenu';
import closeIcon from '../../../../../assets/images/closeSvgIcon.svg';
import MyIMSErrorStatus from '../../../../../assets/images/myimsstatus.svg';
import TestPlayerErrorStatus from '../../../../../assets/images/testplayerstatus.svg';

const ModalComponent = ({
  onClose,
  taskId,
  items,
  showConfirmation,
  setShowConfirmation,
  action,
  setAction,
  editedName,
  setEditedName,
  setFiltersApplied,
  filtersApplied,
  organizationId,
  getTestList,
  filterParams,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useToast();

  const handleAction = (actionType) => {
    setAction(actionType);
    setShowConfirmation(true);
  };
  const handleConfirm = () => {
    if (action === 'unpublish') {
      dispatch(Unpublish_Test(taskId, toast));
    } else if (action === 'publish') {
      dispatch(Published_Test(taskId, toast));
    } else if (action === 'duplicate') {
      // dispatch(Duplicate_Test(taskId, editedName));
      duplicate_test({ name: editedName, id: taskId });
    }
    setShowConfirmation(false);
    if (filtersApplied) {
      getTestList(filterParams);
    } else {
      // getTestList({});
    }
    onClose();
  };

  const duplicate_test = async (formData) => {
    const duplicateUrl = `${GET_TEST_LISTS}duplicate/${organizationId}/`;
    const response = await CallWithAuth('POST', duplicateUrl, formData);
    if (response?.res?.status === 201) {
      const successMessage = response?.res?.data?.message;
      if (toast) {
        toast.add(successMessage, 'success');
      }
      getTestList({});
    } else {
      const errorMessage = response?.res?.data?.detail || response?.res?.data?.error;
      toast?.add(errorMessage, 'error');
    }
    return response;
  };

  const handleOutsideClick = (event) => {
    if (event.target.className === 'overlay') {
      onClose();
    }
  };

  const handleCancelDelete = () => {
    setShowConfirmation(false);
    onClose();
  };

  // __________ outside clickable close modal _______________

  const modalRef = useRef();

  const handleOverlayClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      handleCancelDelete();
    }
  };

  useEffect(() => {
    // Attach the event listener when the component mounts
    document.addEventListener('mousedown', handleOverlayClick);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('mousedown', handleOverlayClick);
    };
  }, [handleOverlayClick]);
  const handleNameChange = (e) => {
    setEditedName(e.target.value);
  };

  return (
    <>
      {showConfirmation ? (
        <div className={styleModal.filterModal}>
          <div className={`${styleModal.center_div_quasi} ${styleModal.delete}`} ref={modalRef}>
            {/* TABLE LISTING OF ALL AND MY QUESTION  */}
            <div className={`${styleModal.master_modal} ${styleModal.quasi_test_modal}`}>
              {/* Modal Header with Close Button */}
              <div className={styleModal.modalHeader}>
                <button
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleCancelDelete();
                  }}
                  className={styleModal.modalClose}
                  onClick={handleCancelDelete}
                >
                  <img src={closeIcon} alt="Close" />
                </button>
              </div>
              <div className={`${styleModal.center_text}`} style={{ padding: '20px' }}>
                {action === 'unpublish' && `Are you sure, Do you want to unpublish ( Task : ${taskId} ) ?`}
                {action === 'duplicate' && (
                  <>
                    <div className={style.input_container}>
                      <div className={styleModal.modalBody}>
                        <label>Are you sure you want to duplicate this Test? (Test ID: {taskId})</label>
                      </div>
                      <div className={style.input_label}>
                        <label className="input_label">Enter test name</label>
                        <input
                          className={style.input_field}
                          type="text"
                          value={editedName}
                          onChange={handleNameChange}
                          placeholder="Enter name"
                        />
                      </div>
                    </div>
                  </>
                )}
                {action === 'publish' && `Are you sure, Do you want to publish ( Task : ${taskId} ) ?`}
              </div>

              <div className={` ${styleModal.saveButton_questionBank} ${styleModal.margin_top_20} ${style.center}`}>
                <div className={` ${styleModal.cancel} ${styleModal.pointer}`} onClick={handleCancelDelete}>
                  Cancel
                </div>
                <div>
                  <button className={styleModal.blue_button} onClick={handleConfirm}>
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        // <div className="overlay" style={{ position: 'relative' }} >
        <div
          className={style.threePin}
          ref={modalRef}
          onClick={handleOutsideClick}
          style={{
            position: 'absolute',
            right: '-60px',
            top: '50px',
            gap: items.status === 'Draft' ? '8px' : '10px',
          }}
        >
          <div className={style.editPops}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 14.668H14" stroke="#212529" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
              <path
                d="M8.83958 2.4008L3.36624 8.19413C3.15958 8.41413 2.95958 8.84746 2.91958 9.14746L2.67291 11.3075C2.58624 12.0875 3.14624 12.6208 3.91958 12.4875L6.06624 12.1208C6.36624 12.0675 6.78624 11.8475 6.99291 11.6208L12.4662 5.82746C13.4129 4.82746 13.8396 3.68746 12.3662 2.29413C10.8996 0.914129 9.78624 1.4008 8.83958 2.4008Z"
                stroke="#212529"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.92676 3.36719C8.21342 5.20719 9.70676 6.61385 11.5601 6.80052"
                stroke="#212529"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <div
              className={style.action}
              onClick={() => {
                navigate(`/test-papers-management/edit/${taskId}`);
                //dispatch(Get_Test_Detail_For_Edit(taskId))
              }}
              // onClick={() =>
              //   dispatch(Task_Screen_Change_With_TaskId(taskId, 3))
              // }
            >
              Edit
            </div>
          </div>

          <div className={style.editPops}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_3757_42938)">
                <path
                  d="M9.99967 0.667969H2.66634C1.93301 0.667969 1.33301 1.26797 1.33301 2.0013V10.668C1.33301 11.0346 1.63301 11.3346 1.99967 11.3346C2.36634 11.3346 2.66634 11.0346 2.66634 10.668V2.66797C2.66634 2.3013 2.96634 2.0013 3.33301 2.0013H9.99967C10.3663 2.0013 10.6663 1.7013 10.6663 1.33464C10.6663 0.967969 10.3663 0.667969 9.99967 0.667969ZM12.6663 3.33464H5.33301C4.59967 3.33464 3.99967 3.93464 3.99967 4.66797V14.0013C3.99967 14.7346 4.59967 15.3346 5.33301 15.3346H12.6663C13.3997 15.3346 13.9997 14.7346 13.9997 14.0013V4.66797C13.9997 3.93464 13.3997 3.33464 12.6663 3.33464ZM11.9997 14.0013H5.99967C5.63301 14.0013 5.33301 13.7013 5.33301 13.3346V5.33464C5.33301 4.96797 5.63301 4.66797 5.99967 4.66797H11.9997C12.3663 4.66797 12.6663 4.96797 12.6663 5.33464V13.3346C12.6663 13.7013 12.3663 14.0013 11.9997 14.0013Z"
                  fill="#212529"
                />
              </g>
              <defs>
                <clipPath id="clip0_3757_42938">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <div className={style.action} onClick={() => handleAction('duplicate')}>
              Duplicate
            </div>
          </div>

          <div className={style.editPops}>
            {items.status === 'In-Review' && (
              <>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.62661 7.54033C5.37277 7.28649 4.96121 7.28649 4.70737 7.54033C4.45353 7.79417 4.45353 8.20573 4.70737 8.45957L5.62661 7.54033ZM7.05366 9.88661L6.59404 10.3462C6.84788 10.6001 7.25944 10.6001 7.51328 10.3462L7.05366 9.88661ZM11.2933 6.5729C11.5471 6.31906 11.5471 5.9075 11.2933 5.65366C11.0394 5.39982 10.6279 5.39982 10.374 5.65366L11.2933 6.5729ZM8.73331 9.1262C8.98715 8.87236 8.98715 8.46081 8.73331 8.20697C8.47947 7.95312 8.06791 7.95312 7.81407 8.20697L8.73331 9.1262ZM9.37633 6.65137L8.91671 7.11099L9.83595 8.03023L10.2956 7.57061L9.37633 6.65137ZM4.70737 8.45957L6.59404 10.3462L7.51328 9.42699L5.62661 7.54033L4.70737 8.45957ZM7.51328 10.3462L8.73331 9.1262L7.81407 8.20697L6.59404 9.42699L7.51328 10.3462ZM10.2956 7.57061L11.2933 6.5729L10.374 5.65366L9.37633 6.65137L10.2956 7.57061Z"
                    fill="#292D32"
                  />
                  <path
                    d="M3.23872 3.33203C2.05989 4.53453 1.33301 6.18173 1.33301 7.9987C1.33301 11.6806 4.31778 14.6654 7.99967 14.6654C9.83012 14.6654 11.4883 13.9277 12.693 12.7334M4.83357 2.13036C5.77544 1.62113 6.8538 1.33203 7.99967 1.33203C11.6816 1.33203 14.6663 4.3168 14.6663 7.9987C14.6663 9.07777 14.41 10.097 13.9548 10.9987"
                    stroke="#292D32"
                    strokeWidth="1.3"
                    strokeLinecap="round"
                  />
                </svg>

                <div className={style.action} onClick={() => handleAction('publish')}>
                  Publish
                </div>
              </>
            )}

            {items.status === 'Published' && (
              <>
                <>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5.62661 7.54033C5.37277 7.28649 4.96121 7.28649 4.70737 7.54033C4.45353 7.79417 4.45353 8.20573 4.70737 8.45957L5.62661 7.54033ZM7.05366 9.88661L6.59404 10.3462C6.84788 10.6001 7.25944 10.6001 7.51328 10.3462L7.05366 9.88661ZM11.2933 6.5729C11.5471 6.31906 11.5471 5.9075 11.2933 5.65366C11.0394 5.39982 10.6279 5.39982 10.374 5.65366L11.2933 6.5729ZM8.73331 9.1262C8.98715 8.87236 8.98715 8.46081 8.73331 8.20697C8.47947 7.95312 8.06791 7.95312 7.81407 8.20697L8.73331 9.1262ZM9.37633 6.65137L8.91671 7.11099L9.83595 8.03023L10.2956 7.57061L9.37633 6.65137ZM4.70737 8.45957L6.59404 10.3462L7.51328 9.42699L5.62661 7.54033L4.70737 8.45957ZM7.51328 10.3462L8.73331 9.1262L7.81407 8.20697L6.59404 9.42699L7.51328 10.3462ZM10.2956 7.57061L11.2933 6.5729L10.374 5.65366L9.37633 6.65137L10.2956 7.57061Z"
                      fill="#292D32"
                    />
                    <path
                      d="M1.33366 1.33203L14.667 14.6654"
                      stroke="#292D32"
                      strokeWidth="1.3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3.23872 3.33203C2.05989 4.53453 1.33301 6.18173 1.33301 7.9987C1.33301 11.6806 4.31778 14.6654 7.99967 14.6654C9.83012 14.6654 11.4883 13.9277 12.693 12.7334M4.83357 2.13036C5.77544 1.62113 6.8538 1.33203 7.99967 1.33203C11.6816 1.33203 14.6663 4.3168 14.6663 7.9987C14.6663 9.07777 14.41 10.097 13.9548 10.9987"
                      stroke="#292D32"
                      strokeWidth="1.3"
                      strokeLinecap="round"
                    />
                  </svg>

                  <div className={style.action} onClick={() => handleAction('unpublish')}>
                    Unpublish
                  </div>
                </>
              </>
            )}
          </div>
        </div>
        // </div>
      )}
    </>
  );
};

const TestList = () => {
  const dispatch = useDispatch();
  const toast = useToast();
  const { getTestCreationData, publishTestData, unpublishTestData } = useSelector((state) => state.GetAllData);
  const navigate = useNavigate();
  //  FILTERS
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedId, setSelectedId] = useState([]);
  const [selecteStatus, setSelecteStatus] = useState([]);
  // const [academicYear, setAcademicYear] = useState('');
  const [multiselectedFreeTag, setmultiSelectedFreeTag] = useState([]);
  const [multiselectedAuthorTag, setmultiSelectedAuthorTag] = useState([]);
  const [selecetdPlayer, setSelectedPlayer] = useState([]);
  const [selectedYearAfter, setSelectedYearAfter] = useState('');
  const [selectedYearBefore, setSelectedYearBefore] = useState('');
  const [testType, setTestType] = useState('');
  const [selectQuestionBank, setSelectQuestionBank] = useState('');

  /********  Sorting by below */
  const [sort, setSort] = useState('');
  const [sortId, setSortId] = useState(true);
  const [sortTestName, setSortTestName] = useState(true);
  const [sortProductType, setSortProductType] = useState(true);
  const [sortTestType, setSortTestType] = useState(true);
  const [sortQuestionbankName, setSortQuestionbankName] = useState(true);
  const [sortCreatedAt, setSortCreatedAt] = useState(true);
  const [sortCreatedBy, setSortCreatedBy] = useState(true);
  const [sortAcademicYear, setSortAcademicYear] = useState(true);
  const [sortStatus, setSortStatus] = useState(true);
  const [totalCount, setTotalCount] = useState(getTestCreationData?.count ?? 0);
  const [limit] = useState(50);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setTotalCount(getTestCreationData?.count);
    setIsLoading(false);
  }, [getTestCreationData]);
  useEffect(() => {
    if (publishTestData?.status === 200) {
      getTestList({});
    }
  }, [publishTestData]);
  useEffect(() => {
    if (unpublishTestData?.status === 200) {
      getTestList({});
    }
  }, [unpublishTestData]);

  const filterParams = {
    ids: Array.isArray(selectedId) ? selectedId.map(Number).join(',') : Number(selectedId) || '',
    status: Array.isArray(selecteStatus)
      ? selecteStatus
          .map((status) => {
            if (status === 'Draft') return 0;
            if (status === 'In-Review') return 1;
            if (status === 'Published') return 2;
            return '';
          })
          .join(',')
      : '',
    free_tags: multiselectedFreeTag?.map((tag) => tag.id).join(','),
    author_tags: Array.isArray(multiselectedAuthorTag)
      ? multiselectedAuthorTag?.map((tag) => Number(tag.id)).join(',')
      : '',
    player_tags: Array.isArray(selecetdPlayer) ? selecetdPlayer?.map((tag) => Number(tag.id)).join(',') : '',
    after: selectedYearAfter || '',
    before: selectedYearBefore || '',
    test_types: testType || '',
    question_banks: selectQuestionBank || '',
  };
  const organizationId = localStorage.getItem('selectedOrgId');

  const handleFilterStateChange = (
    newMultiAuthorTag,
    newMultiFreeTag,
    newSearchId,
    newSelecteStatus,
    newSelecetdPlayer,
    YearAfter,
    YearBefore,
    testTypeid,
    QuestionBank
  ) => {
    setmultiSelectedAuthorTag(newMultiAuthorTag);
    setmultiSelectedFreeTag(newMultiFreeTag);
    setSelectedId(newSearchId);
    setSelecteStatus(newSelecteStatus);
    setSelectedPlayer(newSelecetdPlayer);
    setSelectedYearAfter(YearAfter);
    setSelectedYearBefore(YearBefore);
    setTestType(testTypeid);
    setSelectQuestionBank(QuestionBank);
    setFiltersApplied(true);
    getTestList(filterParams);
    setCurrentPage(1);
  };
  const getTestList = async (filterData) => {
    setIsLoading(true);
    let url = `${GET_TEST_LISTS}${organizationId}/?keyword=${key ?? ''}&sort=${sort}`;
    if (limit) {
      url += `&limit=${limit}`;
    }
    if (currentPage) {
      url += `&page=${currentPage}`;
    }
    // Check if filterParams is not empty
    if (Object.keys(filterData).length > 0) {
      url += `&player_types=${filterData.player_tags}&free_tags=${filterData.free_tags}&ids=${filterData.ids}&authors=${filterData.author_tags}&after=${filterData.after}&before=${filterData.before}&question_banks=${filterData.question_banks}&test_type=${filterData.test_types}&status=${filterData.status}`;
    }
    const result = await CallWithAuth('GET', url);
    if (result?.res?.status === 200) {
      setIsLoading(false);
      const response = result?.res;
      dispatch({ type: GET_TEST_LISTING_SUCCESS, response });
    } else {
      const response = result?.res;
      dispatch({ type: GET_TEST_LISTING_FAIL, response });
    }
  };
  const key = '';
  useEffect(() => {
    if (currentPage && currentPage > 0) {
      if (filtersApplied) {
        getTestList(filterParams);
      } else {
        getTestList({});
      }
    }
  }, [
    sort,
    filtersApplied,
    sortId,
    sortTestName,
    sortProductType,
    sortTestType,
    sortQuestionbankName,
    sortCreatedAt,
    sortCreatedBy,
    sortAcademicYear,
    sortStatus,
    limit,
    key,
    currentPage,
    organizationId,
  ]);
  const [sortConfig, setSortConfig] = useState({
    field: 'updated_at',
    direction: 'desc',
    sort: '-updated_at',
  });

  const handleSort = (field) => {
    setSortConfig((prevConfig) => {
      let direction, sortValue;

      if (field === 'updated_at') {
        if (prevConfig.field !== field) {
          direction = 'desc';
          sortValue = `-${field}`;
        } else {
          // Subsequent clicks toggle between asc and desc
          direction = prevConfig.direction === 'asc' ? 'desc' : 'asc';
          sortValue = direction === 'desc' ? `-${field}` : field;
        }
      } else {
        // General sorting logic for other fields
        direction = prevConfig.field === field && prevConfig.direction === 'asc' ? 'desc' : 'asc';
        sortValue = direction === 'desc' ? `-${field}` : field;
      }

      setSort(sortValue);
      setSortConfig({ field, direction, sort: sortValue });

      // Reset pagination
      setOffset(0);
      setCurrentPage(1);
      return { field, direction, sort: sortValue };
    });
  };
  /***********  SORTING OVER *******************/

  // ________ filter modal open  ________
  const [modalFilter, setModalFilter] = useState(false);

  const openModalFilter = () => {
    setModalFilter(true);
  };

  const closeModalFilter = () => {
    setCurrentPage(1);
    setOffset(0);
    setModalFilter(false);
  };

  const resetFilter = () => {
    setCurrentPage(1);
    setSelectedYearAfter('');
    setSelectedYearBefore('');
    setSelectedId([]);
    setSelecteStatus([]);
    setSelectQuestionBank('');
    setSelectedPlayer([]);
    setTestType('');
    setmultiSelectedAuthorTag([]);
    setmultiSelectedFreeTag([]);
    // Delay the call until after all states are updated
    setTimeout(() => {
      const clearedFilter = {
        player_tags: [],
        free_tags: [],
        ids: [],
        author_tags: [],
        after: '',
        before: '',
        question_banks: '',
        test_types: '',
        status: [],
      };
      getTestList(clearedFilter);
    }, 0);
  };

  /*****Function to open edit / delete modal */
  const [showModal, setShowModal] = useState({});
  const [showConfirmationByIndex, setShowConfirmationByIndex] = useState({});
  const [actionByIndex, setActionByIndex] = useState({});
  const [editedNameByIndex, setEditedNameByIndex] = useState({});
  const handleClick = (index) => {
    setShowModal((prevState) => {
      const nextOpen = !prevState[index];
      if (nextOpen) {
        setShowConfirmationByIndex((prev) => ({ ...prev, [index]: false }));
        setActionByIndex((prev) => ({ ...prev, [index]: '' }));
      }
      return {
        ...prevState,
        [index]: nextOpen,
      };
    });
  };

  const getRotation = (field) => {
    if (field === 'updated_at') {
      // Handle 'updated_at' specifically for upside-down rotation
      if (sortConfig.sort === '-updated_at') return 'rotate(180deg)';
      if (sortConfig.sort === 'updated_at') return 'rotate(0deg)';
    }
    if (sortConfig.field !== field) return 'rotate(0deg)';
    return sortConfig.direction === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)';
  };
  // Helper function to get icon color
  const getIconColor = (field) => {
    return sortConfig.field === field ? '#00ABFB' : '#999090';
  };

  return (
    <div className={style.test_listing_page}>
      <div style={{ display: 'flex' }} className={style.upperSection}>
        <div style={{ flex: 2 }} className={style.text}>
          <span>Test Papers</span>
        </div>
        <div className={style.midValues}>
          {/* <div className={style.search_listing}>
            <div className={style.tag_icon}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18Z"
                  stroke="#212529"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M18.2598 19.2592L16.1406 16.8594"
                  stroke="#212529"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <span>Templates</span>
            </div>

            <div className={style.input_search}>
              <svg
                style={{ marginTop: "10px", marginLeft: "10px" }}
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="20" height="20" rx="4" fill="#272727" />
                <path
                  d="M5.64103 10.7693H9.23072V14.359C9.23072 14.7179 9.51278 15 9.87175 15C10.2307 15 10.5128 14.7179 10.5128 14.359V10.7693H14.359C14.7179 10.7693 15 10.4872 15 10.1283C15 9.76928 14.7179 9.48722 14.359 9.48722H10.5128V5.64103C10.5128 5.28206 10.2307 5 9.87175 5C9.51278 5 9.23072 5.28206 9.23072 5.64103V9.48722H5.64103C5.28206 9.48722 5 9.76928 5 10.1283C5 10.4872 5.28206 10.7693 5.64103 10.7693Z"
                  fill="white"
                />
              </svg>
              <input
                style={{ borderRadius: "24px" }}
                type="search"
                id="searchInput"
                placeholder="Search by product types and templates"
              />
            </div>
          </div> */}

          <div className={style.filter} style={{ width: '100%' }}>
            <div className={style.pointer} onClick={() => openModalFilter()}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.39844 2.10156H18.5984C19.6984 2.10156 20.5984 3.00156 20.5984 4.10156V6.30156C20.5984 7.10156 20.0984 8.10156 19.5984 8.60156L15.2984 12.4016C14.6984 12.9016 14.2984 13.9016 14.2984 14.7016V19.0016C14.2984 19.6016 13.8984 20.4016 13.3984 20.7016L11.9984 21.6016C10.6984 22.4016 8.89844 21.5016 8.89844 19.9016V14.6016C8.89844 13.9016 8.49844 13.0016 8.09844 12.5016L4.29844 8.50156C3.79844 8.00156 3.39844 7.10156 3.39844 6.50156V4.20156C3.39844 3.00156 4.29844 2.10156 5.39844 2.10156Z"
                  stroke="#212529"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span>Filter</span>
            </div>
            <button
              onClick={() => resetFilter()}
              style={{ cursor: 'pointer', paddingLeft: '20px', border: 'none', background: 'none' }}
            >
              <div className={style.reverse_drop}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0001 5.40039C11.022 5.40039 10.1345 5.557 9.32483 5.79899C8.92796 5.91759 8.51009 5.69201 8.39148 5.29514C8.27288 4.89827 8.49846 4.4804 8.89532 4.36179C9.82561 4.08378 10.8582 3.90039 12.0001 3.90039C17.2043 3.90039 21.4201 8.11618 21.4201 13.3204C21.4201 18.5246 17.2043 22.7404 12.0001 22.7404C6.79586 22.7404 2.58008 18.5246 2.58008 13.3204C2.58008 11.3868 3.16704 9.58286 4.16604 8.08437C4.3958 7.73972 4.86146 7.64659 5.2061 7.87635C5.55075 8.10612 5.64388 8.57177 5.41412 8.91642C4.57311 10.1779 4.08008 11.694 4.08008 13.3204C4.08008 17.6962 7.62429 21.2404 12.0001 21.2404C16.3759 21.2404 19.9201 17.6962 19.9201 13.3204C19.9201 8.9446 16.3759 5.40039 12.0001 5.40039Z"
                    fill="#272727"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.2516 1.43431C11.564 1.70627 11.5968 2.18001 11.3248 2.49244L8.43485 5.81244C8.16289 6.12487 7.68915 6.15767 7.37672 5.88571C7.0643 5.61375 7.03149 5.14001 7.30345 4.82758L10.1935 1.50758C10.4654 1.19516 10.9392 1.16235 11.2516 1.43431Z"
                    fill="#272727"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.26342 4.87817C7.50764 4.54361 7.97683 4.47037 8.31139 4.71459L11.6814 7.17459C12.0159 7.41881 12.0892 7.888 11.845 8.22256C11.6007 8.55712 11.1316 8.63036 10.797 8.38614L7.427 5.92614C7.09244 5.68192 7.0192 5.21273 7.26342 4.87817Z"
                    fill="#272727"
                  />
                </svg>
                <p style={{ margin: '0px' }}>Reset Filter</p>
              </div>
            </button>
          </div>
        </div>
        <div className={style.rightButton}>
          <button
            onClick={() => {
              navigate('/test-papers-management/add');
              // dispatch(change_test_screen(1))
            }}
            className={` ${style.add_new_question} ${style.pointer}`}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" fill="white" />
              <path d="M7.5 12H16.5" stroke="#00ABFB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12 16.5V7.5" stroke="#00ABFB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

            <span>Add New Test Paper</span>
          </button>
        </div>
      </div>
      <div className={style.mainSection}>
        {totalCount && totalCount !== 0 ? (
          <div className={style.mainSectiontableWrap}>
            <table>
              <thead>
                <tr>
                  <th className={` ${style.first} ${style.pointer}`}>
                    <span>Test ID</span>
                    <svg
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSort('id');
                      }}
                      width="19"
                      height="12"
                      viewBox="0 0 19 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        marginLeft: '6px',
                        transform: getRotation('id'),
                        transition: 'transform 0.3s ease',
                      }}
                    >
                      <path
                        d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                        fill={getIconColor('id')}
                      />
                      <path
                        d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                        fill={getIconColor('id')}
                      />
                      <path
                        d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                        fill={getIconColor('id')}
                      />
                      <path
                        d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                        fill={getIconColor('id')}
                      />
                    </svg>
                  </th>

                  <th className={` ${style.second} ${style.pointer}`}>
                    <span>Test Name</span>
                    <svg
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSort('test_name');
                      }}
                      width="19"
                      height="12"
                      viewBox="0 0 19 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        marginLeft: '6px',
                        transform: getRotation('test_name'),
                        transition: 'transform 0.3s ease',
                      }}
                    >
                      <path
                        d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                        fill={getIconColor('test_name')}
                      />
                      <path
                        d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                        fill={getIconColor('test_name')}
                      />
                      <path
                        d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                        fill={getIconColor('test_name')}
                      />
                      <path
                        d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                        fill={getIconColor('test_name')}
                      />
                    </svg>
                  </th>
                  <th className={` ${style.third} ${style.pointer}`}>
                    <span>Player Type</span>
                    <svg
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSort('product_type');
                      }}
                      width="19"
                      height="12"
                      viewBox="0 0 19 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        marginLeft: '6px',
                        transform: getRotation('product_type'),
                        transition: 'transform 0.3s ease',
                      }}
                    >
                      <path
                        d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                        fill={getIconColor('product_type')}
                      />
                      <path
                        d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                        fill={getIconColor('product_type')}
                      />
                      <path
                        d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                        fill={getIconColor('product_type')}
                      />
                      <path
                        d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                        fill={getIconColor('product_type')}
                      />
                    </svg>
                  </th>
                  <th className={` ${style.fourth} ${style.pointer}`}>
                    <span>Test Type</span>
                    <svg
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSort('test_type');
                      }}
                      width="19"
                      height="12"
                      viewBox="0 0 19 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        marginLeft: '6px',
                        transform: getRotation('test_type'),
                        transition: 'transform 0.3s ease',
                      }}
                    >
                      <path
                        d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                        fill={getIconColor('test_type')}
                      />
                      <path
                        d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                        fill={getIconColor('test_type')}
                      />
                      <path
                        d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                        fill={getIconColor('test_type')}
                      />
                      <path
                        d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                        fill={getIconColor('test_type')}
                      />
                    </svg>
                  </th>
                  <th className={` ${style.fifth} ${style.pointer}`}>
                    <span>Question Bank</span>
                  </th>
                  <th className={` ${style.sixth} ${style.pointer}`}>
                    <span>Created On</span>
                    <svg
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSort('updated_at');
                      }}
                      width="19"
                      height="12"
                      viewBox="0 0 19 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        marginLeft: '6px',
                        transform: getRotation('updated_at'),
                        transition: 'transform 0.3s ease',
                      }}
                    >
                      <path
                        d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                        fill={getIconColor('updated_at')}
                      />
                      <path
                        d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                        fill={getIconColor('updated_at')}
                      />
                      <path
                        d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                        fill={getIconColor('updated_at')}
                      />
                      <path
                        d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                        fill={getIconColor('updated_at')}
                      />
                    </svg>
                  </th>
                  <th className={` ${style.seventh} ${style.pointer}`}>
                    <span>Author</span>
                    <svg
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSort('created_by');
                      }}
                      width="19"
                      height="12"
                      viewBox="0 0 19 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        marginLeft: '6px',
                        transform: getRotation('created_by'),
                        transition: 'transform 0.3s ease',
                      }}
                    >
                      <path
                        d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                        fill={getIconColor('created_by')}
                      />
                      <path
                        d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                        fill={getIconColor('created_by')}
                      />
                      <path
                        d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                        fill={getIconColor('created_by')}
                      />
                      <path
                        d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                        fill={getIconColor('created_by')}
                      />
                    </svg>
                  </th>
                  <th className={` ${style.eighth} ${style.pointer}`}>
                    <span>Academic Year</span>
                    <svg
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSort('academic_year');
                      }}
                      width="19"
                      height="12"
                      viewBox="0 0 19 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        marginLeft: '6px',
                        transform: getRotation('academic_year'),
                        transition: 'transform 0.3s ease',
                      }}
                    >
                      <path
                        d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                        fill={getIconColor('academic_year')}
                      />
                      <path
                        d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                        fill={getIconColor('academic_year')}
                      />
                      <path
                        d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                        fill={getIconColor('academic_year')}
                      />
                      <path
                        d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                        fill={getIconColor('academic_year')}
                      />
                    </svg>
                  </th>
                  <th className={` ${style.ninth} ${style.pointer}`}>
                    <span>Status</span>
                    <svg
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSort('status');
                      }}
                      width="19"
                      height="12"
                      viewBox="0 0 19 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        marginLeft: '6px',
                        transform: getRotation('status'),
                        transition: 'transform 0.3s ease',
                      }}
                    >
                      <path
                        d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                        fill={getIconColor('status')}
                      />
                      <path
                        d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                        fill={getIconColor('status')}
                      />
                      <path
                        d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                        fill={getIconColor('status')}
                      />
                      <path
                        d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                        fill={getIconColor('status')}
                      />
                    </svg>
                  </th>
                  <th className={` ${style.tenth} ${style.pointer}`}>
                    <span>MyIMS Sync Status</span>
                  </th>
                  <th className={` ${style.eleventh} ${style.pointer}`}>
                    <span>Test Player Sync Status</span>
                  </th>
                  <th className={` ${style.twelfth}`}></th>
                </tr>
              </thead>
              {isLoading ? (
                <tbody>
                  <tr
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      textAlign: 'center',
                      padding: '20px',
                      fontSize: '15px',
                      fontFamily: 'IBM Plex Sans',
                    }}
                  >
                    <td colSpan="7" style={{ padding: '20px' }}>
                      Loading...
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {getTestCreationData?.results?.map((items, i) => (
                    <tr key={i + items}>
                      <td key={i + items}>
                        <div className={style.testId}>
                          <NativeButton onClick={() => navigate(`/test-papers-management/details/${items.id}`)}>
                            <u
                              style={{
                                fontWeight: 500,
                                color: '#00abfb',
                                cursor: 'pointer',
                              }}
                            >
                              {items.id}
                            </u>
                          </NativeButton>
                        </div>
                      </td>
                      <td>
                        <span>{items.test_name}</span>
                        <span
                          style={{
                            display: 'flex',
                            gap: '5px',
                            width: 'fit-content',
                            flexWrap: 'wrap',
                          }}
                          className={style.description_detail}
                        >
                          {items?.free_tags.map((item, i) => (
                            <button key={i + item} className={style.general_button} style={{ padding: '6px 12px' }}>
                              {item.name}
                            </button>
                          ))}
                        </span>
                      </td>
                      <td>
                        <span
                          style={{
                            display: 'flex',
                            gap: '5px',
                            width: 'fit-content',
                            flexWrap: 'wrap',
                          }}
                          className={style.description_detail}
                        >
                          <button className={style.template_button}>{items.player_type}</button>
                        </span>
                      </td>
                      <td>{items.test_type}</td>
                      <td>
                        {items?.question_banks.slice(0, 3).map((item, i) => (
                          <button key={i + item} className={style.template_button}>
                            {item}
                          </button>
                        ))}
                        {items?.question_banks.length > 3 && (
                          <button className={style.template_button}>+{items.question_banks.length - 3}</button>
                        )}
                      </td>
                      <td>{moment(items?.created_on).format('DD MMM YYYY')}</td>
                      <td>{items.author}</td>
                      <td>{items.academic_year}</td>
                      <td>
                        <div className={style.user_management_table_body_content} style={{ position: 'relative' }}>
                          {items.status === 'Draft' ? <button className={style.draft}>{items.status}</button> : ''}
                          {items.status === 'Published' ? (
                            <button className={style.published}>{items.status}</button>
                          ) : (
                            ''
                          )}
                          {items.status === 'In-Review' ? (
                            <button className={style.in_review}>{items.status}</button>
                          ) : (
                            ''
                          )}
                        </div>
                      </td>
                      <td>
                        <div className={style.user_management_table_body_content} style={{ position: 'relative' }}>
                          {!['CAT', 'AREA_TEST', 'PRACTICE_TEST'].includes(items.player_type) && (
                            <img
                              onError={(e) => {
                                e.target.src = MyIMSErrorStatus;
                              }}
                              alt="imsTestStatus"
                              src={IMS_TEST_STATUS(items.id)}
                            />
                          )}
                        </div>
                      </td>
                      <td>
                        <div className={style.user_management_table_body_content} style={{ position: 'relative' }}>
                          {!['CAT', 'AREA_TEST', 'PRACTICE_TEST'].includes(items.player_type) && (
                            <img
                              onError={(e) => {
                                e.target.src = TestPlayerErrorStatus;
                              }}
                              alt="testPlayerStatus"
                              src={TEST_PLAYER_STATUS(items.id)}
                            />
                          )}
                        </div>
                      </td>
                      <td>
                        <div style={{ position: 'relative' }}>
                          <svg
                            style={{ cursor: 'pointer', padding: '0 12px' }}
                            width="4"
                            height="16"
                            viewBox="0 0 4 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => handleClick(i)}
                          >
                            <path
                              d="M2 12C2.53043 12 3.03914 12.2107 3.41421 12.5858C3.78929 12.9609 4 13.4696 4 14C4 14.5304 3.78929 15.0391 3.41421 15.4142C3.03914 15.7893 2.53043 16 2 16C1.46957 16 0.96086 15.7893 0.585787 15.4142C0.210714 15.0391 0 14.5304 0 14C0 13.4696 0.210714 12.9609 0.585787 12.5858C0.96086 12.2107 1.46957 12 2 12ZM2 6C2.53043 6 3.03914 6.21071 3.41421 6.58579C3.78929 6.96086 4 7.46957 4 8C4 8.53043 3.78929 9.03914 3.41421 9.41421C3.03914 9.78929 2.53043 10 2 10C1.46957 10 0.96086 9.78929 0.585787 9.41421C0.210714 9.03914 0 8.53043 0 8C0 7.46957 0.210714 6.96086 0.585787 6.58579C0.96086 6.21071 1.46957 6 2 6ZM2 0C2.53043 0 3.03914 0.210714 3.41421 0.585786C3.78929 0.960859 4 1.46957 4 2C4 2.53043 3.78929 3.03914 3.41421 3.41421C3.03914 3.78929 2.53043 4 2 4C1.46957 4 0.96086 3.78929 0.585787 3.41421C0.210714 3.03914 0 2.53043 0 2C0 1.46957 0.210714 0.960859 0.585787 0.585786C0.96086 0.210714 1.46957 0 2 0Z"
                              fill="#272727"
                            />
                          </svg>

                          {showModal[i] && (
                            <ModalComponent
                              onClose={() => handleClick(i)}
                              index={i}
                              items={items}
                              taskId={items.id}
                              showConfirmation={showConfirmationByIndex[i]}
                              setShowConfirmation={(value) =>
                                setShowConfirmationByIndex((prev) => ({ ...prev, [i]: value }))
                              }
                              action={actionByIndex[i] || ''}
                              setAction={(value) => setActionByIndex((prev) => ({ ...prev, [i]: value }))}
                              editedName={editedNameByIndex[i] || ''}
                              setEditedName={(value) => setEditedNameByIndex((prev) => ({ ...prev, [i]: value }))}
                              filtersApplied={filtersApplied}
                              setFiltersApplied={setFiltersApplied}
                              organizationId={organizationId}
                              getTestList={getTestList}
                              filterParams={filterParams}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
        ) : (
          <>
            {getTestCreationData?.error ? (
              <div className={style.noData}>
                <div className={style.noDataText}>No data found.</div>
              </div>
            ) : (
              isLoading && (
                <div
                  colSpan="7"
                  style={{
                    textAlign: 'center',
                    padding: '20px',
                    fontSize: '15px',
                    fontFamily: 'IBM Plex Sans',
                  }}
                >
                  Loading...
                </div>
              )
            )}
          </>
        )}
        {/* <div className='paginationTableWrapper'> */}
        {!getTestCreationData?.error && getTestCreationData?.results?.length !== 0 && (
          <div className={style.testPaperListingPagination}>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              limit={limit}
              totalCount={totalCount}
              offset={offset}
              setOffset={setOffset}
            />
          </div>
        )}
        {/* </div> */}
        {modalFilter && (
          <TestFilterModal
            modalFilter={modalFilter}
            closeModalFilter={closeModalFilter}
            onFilterStateChange={handleFilterStateChange}
            setFiltersApplied={setFiltersApplied}
            multiselectedAuthorTag={multiselectedAuthorTag}
            setMultiselectedAuthorTag={setmultiSelectedAuthorTag}
            multiselectedFreeTag={multiselectedFreeTag}
            setmultiSelectedFreeTag={setmultiSelectedFreeTag}
            selectedId={selectedId}
            setSelectedId={setSelectedId}
            selecteStatus={selecteStatus}
            setSelecteStatus={setSelecteStatus}
            selectQuestionBank={selectQuestionBank}
            setSelectQuestionBank={setSelectQuestionBank}
            selecetdPlayer={selecetdPlayer}
            setSelectedPlayer={setSelectedPlayer}
            testType={testType}
            setTestType={setTestType}
            selectedYearExclude={selectedYearBefore}
            setSelectedYearExclude={setSelectedYearBefore}
            selectedYear={selectedYearAfter}
            setSelectedYear={setSelectedYearAfter}
          />
        )}
      </div>
    </div>
  );
};

export default TestList;
